import Button, { ButtonProps } from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
// eslint-disable-next-line import/named
// eslint-disable-next-line import/named
import { Colors, LooseObject } from '@rentguru/commons-utils';
import clsx from 'clsx';
import { ReactNode, ElementType } from 'react';

export const actionButtonSecondStyles = makeStyles({
  root: {
    fontSize: 12,
    fontWeight: 'bold',
    color: Colors.DARK_SLATE_GREY,
    textAlign: 'center',
    background: Colors.CLASSICAL_WHITE,
    borderRadius: 60,
    textTransform: 'unset',
    lineHeight: '20px',
    borderCollapse: 'collapse',
    outline: `1px solid ${Colors.PORCELAIN_GREY_3}`,
    fontStyle: 'normal',
    letterSpacing: 0,
    padding: '5px 15px',
  },
  buttonWithMargin: {
    marginRight: 20,
  },
});

export interface ActionButtonSecondProps extends ButtonProps {
  to?: LooseObject | string;
  component?: ReactNode | ElementType;
}
export const ActionButtonSecond = ({ children, style = {}, className, ...rest }: ActionButtonSecondProps) => {
  const classes = actionButtonSecondStyles();

  return (
    <Button className={clsx(classes.root, className)} style={style} {...rest}>
      {children}
    </Button>
  );
};
